import React, { useState } from "react";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import FileUpload from "../../../FileUploads/FileUpload";
import { toast } from "react-toastify";

const RaiseIssue = ({
  documentUploadUrlPublic,
  documentUrlDataPublic = [],
  history,
  saveTicketDetails
}) => {

  const [inputList, setInputList] = useState({ issue: "", attachment: "" });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (key, val) => {
    setInputList(prevState => ({
      ...prevState,
      [key]: val
    }));
  };

  const handleSubmit = async (e) => {
        e.preventDefault();
        if (!inputList.issue) {
        toast.error('Please enter the issue!');
        return;
        }

        // Split the issue description by spaces to count words
        const wordCount = inputList.issue.trim().split(/\s+/).length;

        if (wordCount > 150) {
          toast.error('Issue description should not exceed 150 words!');
          return;
        }

        if (wordCount < 10) {
          toast.error('Issue description should be more than 10 words!');
          return;
        }

        const payload = {
        issue: inputList.issue,
        attachment: inputList.attachment
        };

        setIsLoading(true);
        const res = await saveTicketDetails(payload);
        console.log("RES:", res);
        if(res){
            toast.success('Ticket raised successfully!');
            window.location.href = '/ticket-details';
        } else {
            toast.error(res.message || 'Failed to raise issue.');
        }
        setIsLoading(false);
    };


  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Raise Ticket"} history={history} />
            <div className="container-fluid common-bg">
              <div className="container-fluid bootstrap snippets bg-white">
                <div className="row justify-content-center mt-5">
                  <div className="col-lg-8 col-md-10">
                    <div className="card shadow-sm" style={{backgroundColor: "#f3f1ef" }}>
                      <div className="heading mt-5" style={{ display: "flex", justifyContent: "center", color: "#473381" }}>
                          <h3>Raise a Ticket</h3>
                      </div>

                      <div className="card-body">
                        <form onSubmit={handleSubmit}>
                          <div className="mb-3">
                            <textarea
                              className="form-control form-control-user cus-red"
                              placeholder="Issue Description*"
                              onChange={(e) => handleInputChange("issue", e.target.value)}
                              rows="4"
                              cols="50"
                              isStarRequired={true}
                            />
                          </div>
                          <div className="mb-3">
                            <FileUpload
                              id={"addAttachment"}
                              accept=".png,.jpg,.jpeg,.mp3"
                              documentUploadUrl={documentUploadUrlPublic}
                              documentUrlData={documentUrlDataPublic}
                              onChange={(e) => handleInputChange("attachment", e)}
                              prefilledFilename={""}
                              multiple={true}
                            >
                              File Attachment
                            </FileUpload>
                          </div>
                          <div className="text-center mt-4">
                            <button type="submit" className=" col-md-6 btn btn-primary">
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RaiseIssue;
